import styled from 'styled-components'

import { Paragraph } from 'src/styles/typography/typography'

interface Props {
  toScroll: boolean
}

export const ScoreReviewsBase = styled.div<Props>`
  grid-area: scoreReviews;
  display: inline-flex;
  align-items: center;
  cursor: ${props => (props.toScroll ? 'pointer' : '')};
`

export const Category = styled.span<{ color?: string }>`
  color: ${props => props.color};
  font-size: 16px;
  font-weight: 700;
  text-transform: capitalize;
  margin-inline: 8px;
  margin-block: 0;
`

export const NewComments = styled(Paragraph)`
  text-transform: lowercase;
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  text-decoration-line: underline;
`
